import React, { FunctionComponent } from 'react';
import { Experiments } from '../../constants/experiments';

import { DonateButton } from '../DonateButton/DonateButton';
import { Share } from '../SocialButtons/Share';

const FundraisingCTA: FunctionComponent = () => (
  <>
    <DonateButton
      key="donateButton"
      className="jg-space-mrsm jg-space-mrn@lg jg-space-mbsm"
      trackingDataPageSection="FundraisingCTA"
      experiments={[
        // B2C_041 - Donation Prompts Part 2
        // Remove the experiment slug from the list below when removing this experiment
        Experiments.b2c_041_fundraising_page_donation_prompts_2,
        Experiments.b2c_036_donate_button_colour,
        Experiments.b2c_038_secure_donate_buttons,
        // B2C_029 - First to donate
        // Can be removed when experiment has ended
        Experiments.b2c_029_first_to_donate,
        // B2C_040 - Proposition Bar
        // Remove this experiment when complete
        Experiments.b2c_040_frp_trust_proposition_bar,
      ]}
      successType="StaticDonateButtonClick"
    />
    <Share successType="StaticShareButtonClick" />
  </>
);

export default FundraisingCTA;
